import clsx from 'clsx';
import React from 'react';

import Button, { ButtonProps } from '@components/Button';

type TopNavItemProps = ButtonProps & {
  showLeftDivider?: boolean;
  isScrollStyle?: boolean;
};

const TopNavItem = ({ className, showLeftDivider, isScrollStyle, ...rest }: TopNavItemProps) => (
  <li>
    <Button
      className={clsx(
        className,
        'relative block border-none bg-transparent py-12 font-suisse-intl-mono text-overline-md text-black transition-colors hover:text-primary-magenta focus:text-primary-magenta',
        {
          'before:absolute before:-left-36 before:bottom-0 before:h-px before:w-36 before:origin-bottom-right before:rotate-[50deg] before:bg-black before:content-[""]':
            showLeftDivider,
          'px-10 pb-36 pt-[30px] text-white': isScrollStyle,
          'px-16': !isScrollStyle,
        }
      )}
      {...rest}
    />
  </li>
);

export default TopNavItem;
